export const pumpSelector = {
  cta: 'Go Green and Reuse Pumps',
  ctaOptedOut: 'No, don’t include pumps in this order',
  ctaOptedIn: 'Yes, include pumps in this order',
  description:
    'Exclude pumps from this shipment and reuse the ones you already have. ' +
    'Every little bit helps!',
};

export const uspsDelayNotice =
  'USPS is experiencing delays, your order may take longer than expected to get to you.';
